interface InfoSVGProps {
  color: string;
  style: React.CSSProperties;
}

const InfoSVG = ({ color, style }: InfoSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.08337 24.9997C2.08337 37.6562 12.3435 47.9163 25 47.9163C37.6566 47.9163 47.9167 37.6562 47.9167 24.9997C47.9167 12.3432 37.6566 2.08301 25 2.08301C12.3435 2.08301 2.08337 12.3432 2.08337 24.9997ZM43.75 24.9997C43.75 35.355 35.3554 43.7497 25 43.7497C14.6447 43.7497 6.25004 35.355 6.25004 24.9997C6.25004 14.6443 14.6447 6.24967 25 6.24967C35.3554 6.24967 43.75 14.6443 43.75 24.9997ZM27.0909 29.1629H29.1729V33.3296H20.8395V29.1629H22.9229V24.9962H20.8395V20.8296H27.0909V29.1629ZM27.0847 16.6629C27.0847 17.8135 26.1517 18.7462 25.0007 18.7462C23.8498 18.7462 22.9167 17.8135 22.9167 16.6629C22.9167 15.5123 23.8498 14.5796 25.0007 14.5796C26.1517 14.5796 27.0847 15.5123 27.0847 16.6629Z"
      fill={color}
    />
  </svg>
);

export default InfoSVG;
